
<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :user="user_data" />
            </div>
          </vs-tab>
          <!--
          <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <user-edit-tab-social class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          -->
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>
<script>
import Service from "../../../services";

import UserEditTabAccount from "./components/UserEditTabAccount.vue";

export default {
  components: { UserEditTabAccount },
  props: ["id"],
  data() {
    return {
      user_data: null,
      user_not_found: false,
      activeTab: 0
    };
  },
  created() {
    let data = {
      e: this.$route.query.e,
      s: this.$route.query.s
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    Service.User.get(this.id, params).then(res => {
      if (!res.success) {
        this.user_not_found = true;
      } else {
        this.user_data = res.data;
      }
    });
  },
  methods: {}
};
</script>